import { render } from "./PDFFormEditorView.vue?vue&type=template&id=356576dc&scoped=true"
import script from "./PDFFormEditorView.vue?vue&type=script&lang=js"
export * from "./PDFFormEditorView.vue?vue&type=script&lang=js"

import "./PDFFormEditorView.vue?vue&type=style&index=0&id=356576dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356576dc"]])

export default __exports__